/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Integration_Embed_Title5Inputs */

const en_svc_ai_integration_embed_title5 = /** @type {(inputs: Svc_Ai_Integration_Embed_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vector search`)
};

const ar_svc_ai_integration_embed_title5 = /** @type {(inputs: Svc_Ai_Integration_Embed_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`البحث بالمتجهات`)
};

const bn_svc_ai_integration_embed_title5 = /** @type {(inputs: Svc_Ai_Integration_Embed_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ভেক্টর সার্চ`)
};

const de_svc_ai_integration_embed_title5 = /** @type {(inputs: Svc_Ai_Integration_Embed_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vektorsuche`)
};

const es_svc_ai_integration_embed_title5 = /** @type {(inputs: Svc_Ai_Integration_Embed_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Búsqueda de vectores`)
};

const fr_svc_ai_integration_embed_title5 = /** @type {(inputs: Svc_Ai_Integration_Embed_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recherche de vecteurs`)
};

const pt_svc_ai_integration_embed_title5 = /** @type {(inputs: Svc_Ai_Integration_Embed_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesquisa vetorial`)
};

const zh_svc_ai_integration_embed_title5 = /** @type {(inputs: Svc_Ai_Integration_Embed_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`矢量搜索`)
};

const tr_svc_ai_integration_embed_title5 = /** @type {(inputs: Svc_Ai_Integration_Embed_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vektör arama`)
};

const ru_svc_ai_integration_embed_title5 = /** @type {(inputs: Svc_Ai_Integration_Embed_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Векторный поиск`)
};

const pl_svc_ai_integration_embed_title5 = /** @type {(inputs: Svc_Ai_Integration_Embed_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyszukiwanie wektorowe`)
};

/**
* | output |
* | --- |
* | "Vector search" |
*
* @param {Svc_Ai_Integration_Embed_Title5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_integration_embed_title5 = /** @type {((inputs?: Svc_Ai_Integration_Embed_Title5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Integration_Embed_Title5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_integration_embed_title5(inputs)
	if (locale === "bn") return bn_svc_ai_integration_embed_title5(inputs)
	if (locale === "de") return de_svc_ai_integration_embed_title5(inputs)
	if (locale === "es") return es_svc_ai_integration_embed_title5(inputs)
	if (locale === "fr") return fr_svc_ai_integration_embed_title5(inputs)
	if (locale === "pt") return pt_svc_ai_integration_embed_title5(inputs)
	if (locale === "zh") return zh_svc_ai_integration_embed_title5(inputs)
	if (locale === "tr") return tr_svc_ai_integration_embed_title5(inputs)
	if (locale === "ru") return ru_svc_ai_integration_embed_title5(inputs)
	if (locale === "pl") return pl_svc_ai_integration_embed_title5(inputs)
	return en_svc_ai_integration_embed_title5(inputs)
});
export { svc_ai_integration_embed_title5 as "svc_ai-integration_EMBED_title" }